import React from "react";

import { useNavigate } from "react-router-dom";
import DetailPagetLayout from "./CarDetailLayout";

import Badge from "shared/Badge/Badge";
import CarDetailImageCollage from "./CarDetailImageCollage";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useData } from "data/data-provider";

interface CarDetailProps {
  // Define any props if needed in the future
}

const CarDetail: React.FC<CarDetailProps> = () => {
  const { selectedCar } = useData();
  const navigate = useNavigate();
  const carPrice = selectedCar?.price
    ? `${selectedCar.price}`
    : "Price not available";
  const renderSection3 = () => {
    return (
      <div className="flex flex-col sm:rounded-2xl border-b sm:border-t sm:border-l sm:border-r border-neutral-200 dark:border-neutral-700 Open adobe brothers game hello send it I believe I don't have a pet wolf hey Megan with him when I get it having a vagina Apple Pay sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="flex flex-col p-2 ">
            <h2 className="text-2xl font-semibold mb-10">Pick Up</h2>
            <div className="flex items-center mb-3">
              <i className="las la-map-marker-alt text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                Auto Rentals AZ Phoenix, AZ 85085
              </span>
            </div>
            <div className="flex items-center">
              <i className="las la-clock text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                Hours of operation: 8:00 am to 8:00 pm
              </span>
            </div>
          </div>

          <div className="flex flex-col p-2 ">
            <h2 className="text-2xl font-semibold mb-10">Drop Off</h2>
            <div className="flex items-center mb-3">
              <i className="las la-map-marker-alt text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                Auto Rentals AZ Phoenix, AZ 85085
              </span>
            </div>
            <div className="flex items-center">
              <i className="las la-clock text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                Hours of operation: 8:00 am to 8:00 pm
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderSection4 = () => {
    return (
      <div className="flex flex-col sm:rounded-2xl border-b sm:border-t sm:border-l sm:border-r border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="flex flex-col p-2 ">
            <h2 className="text-2xl font-semibold mb-12">
              Included in above rate
            </h2>
            <div className="flex items-center mb-3">
              <i className="las la-check-circle text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                Mileage Use: 150 miles a day
              </span>
            </div>
            <div className="flex items-center mb-3">
              <i className="las la-check-circle text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">Gas Policy: Full to Full</span>
            </div>
            <div className="flex items-center">
              <i className="las la-check-circle text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                24/7 contactless pickup & drop-off
              </span>
            </div>
          </div>

          <div className="flex flex-col p-2 ">
            <h2 className="text-2xl font-semibold mb-12">Available Add-Ons</h2>
            <div className="flex items-center mb-3">
              <i className="las la-check-circle text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                Return at any gas level: $8 per gallon compensation
              </span>
            </div>
            <div className="flex items-center mb-3">
              <i className="las la-check-circle text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                Golf Clubs: $30 per Trip (Right handed Male & Female)
              </span>
            </div>
            <div className="flex items-center">
              <i className="las la-check-circle text-gray-600 text-2xl mr-2"></i>
              <span className="text-gray-700">
                Child Safety Seat: $20 per Trip
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderSection2 = () => {
    return (
      <div className="flex flex-col sm:rounded-2xl border-b sm:border-t sm:border-l sm:border-r border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        {" "}
        <h2 className="text-2xl sm:text-3xl lg:text-3xl font-semibold">
          Car Description
        </h2>
        <div className="flex items-center space-x-4">
          <span className="text-base">
            {selectedCar?.description ? selectedCar?.description : "N/A"}
          </span>
        </div>
      </div>
    );
  };
  const renderSection1 = () => {
    return (
      <div className="flex flex-col sm:rounded-2xl border-b sm:border-t sm:border-l sm:border-r border-neutral-200 dark:border-neutral-700 sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        {/* 1 */}
        <div className="flex justify-between items-center">
          <Badge name={selectedCar?.fleet_class?.name} />
        </div>

        {/* 2 */}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">
          {selectedCar?.name}
        </h2>

        {/* 3 */}
        {/* <div className="flex items-center space-x-4">
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1">Phoenix AZ</span>
          </span>
        </div> */}

        {/* 5 */}
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

        {/* 6 */}
        <div className="flex items-center justify-start space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
          <div className="flex items-center space-x-3 ">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.3447 11.1528C20.6254 11.4336 20.7831 11.8157 20.7831 12.2134V19.2814C20.7831 20.1091 20.1128 20.7799 19.2843 20.7814L12.2131 20.7844C11.8161 20.7844 11.4343 20.6262 11.1515 20.3449L5.77652 14.9694C5.44712 16.5393 5.26602 18.2933 5.26602 20.2394C5.26602 20.5155 5.04217 20.7394 4.76602 20.7394C4.48987 20.7394 4.26602 20.5155 4.26602 20.2394C4.26602 17.9629 4.50652 15.9306 4.94022 14.133L1.24001 10.4324C0.653148 9.84704 0.653148 8.89574 1.23954 8.31084L8.30957 1.23984C8.89582 0.653574 9.84542 0.653574 10.4317 1.23984L18.0839 8.89209C18.227 8.52919 18.3544 8.16754 18.4621 7.81299C19.3406 4.92344 18.8298 3.28919 16.7845 3.28919C16.0327 3.28919 15.3164 3.38603 14.6361 3.57157C14.3697 3.64423 14.0948 3.48716 14.0221 3.22075C13.9495 2.95434 14.1065 2.67947 14.373 2.60681C15.1386 2.39799 15.9434 2.28919 16.7845 2.28919C19.7178 2.28919 20.4624 4.67149 19.4189 8.10389C19.2636 8.61454 19.0713 9.13779 18.8509 9.65909L20.3447 11.1528ZM5.24197 13.0204L1.94669 9.72484C1.75108 9.52974 1.75108 9.21304 1.94622 9.01839L9.01667 1.94692C9.21242 1.75121 9.52882 1.75121 9.72457 1.94694L17.6575 9.87989C16.7574 11.8025 15.5062 13.6057 14.4813 14.3876C14.2617 14.5551 14.2195 14.8689 14.387 15.0884C14.5545 15.308 14.8682 15.3502 15.0878 15.1827C16.1894 14.3423 17.4576 12.5647 18.4074 10.6298L19.6376 11.8599C19.7304 11.9528 19.7831 12.0805 19.7831 12.2134V19.2814C19.7831 19.5573 19.5597 19.7809 19.2832 19.7814L12.2129 19.7844C12.0809 19.7844 11.9525 19.7312 11.8577 19.6369L6.05022 13.8288C6.30167 12.9025 6.60812 12.0476 6.96147 11.2623C7.32847 10.4467 7.71987 9.76819 8.10902 9.22049C8.33707 8.89949 8.50922 8.69729 8.59857 8.60794C8.79382 8.41269 8.79382 8.09609 8.59857 7.90084C8.40332 7.70559 8.08672 7.70559 7.89147 7.90084C7.76337 8.02889 7.55502 8.27369 7.29382 8.64129C6.86757 9.24124 6.44362 9.97619 6.04952 10.852C5.74557 11.5275 5.47492 12.25 5.24197 13.0204ZM14.7845 16.2852C15.6124 16.2852 16.2845 15.613 16.2845 14.7852C16.2845 14.509 16.5084 14.2852 16.7845 14.2852C17.0607 14.2852 17.2845 14.509 17.2845 14.7852C17.2845 16.1653 16.1647 17.2852 14.7845 17.2852C13.4044 17.2852 12.2845 16.1653 12.2845 14.7852C12.2845 13.405 13.4044 12.2852 14.7845 12.2852C15.0607 12.2852 15.2845 12.509 15.2845 12.7852C15.2845 13.0613 15.0607 13.2852 14.7845 13.2852C13.9567 13.2852 13.2845 13.9573 13.2845 14.7852C13.2845 15.613 13.9567 16.2852 14.7845 16.2852Z"
                fill="#374151"
                stroke="#374151"
                stroke-width="0.5"
              />
            </svg>

            <span className="">
              $
              {selectedCar?.avg_car_price_per_day
                ? selectedCar?.avg_car_price_per_day
                : 0}{" "}
              <span>per day</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <svg
              width="24"
              height="14"
              viewBox="0 0 24 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.5498 0.050293C5.7373 0.050293 4.9873 0.253418 4.2998 0.659668C3.6123 1.06592 3.06543 1.61279 2.65918 2.30029C2.25293 2.98779 2.0498 3.73779 2.0498 4.55029C2.0498 5.28467 2.21387 5.96826 2.54199 6.60107C2.87012 7.23389 3.32324 7.76123 3.90137 8.18311C2.90137 8.68311 2.09277 9.41357 1.47559 10.3745C0.858398 11.3354 0.549805 12.394 0.549805 13.5503H2.0498C2.0498 12.7378 2.25293 11.9878 2.65918 11.3003C3.06543 10.6128 3.6123 10.0659 4.2998 9.65967C4.9873 9.25342 5.7373 9.05029 6.5498 9.05029C7.3623 9.05029 8.1123 9.25342 8.7998 9.65967C9.4873 10.0659 10.0342 10.6128 10.4404 11.3003C10.8467 11.9878 11.0498 12.7378 11.0498 13.5503H12.5498C12.5498 12.7378 12.7529 11.9878 13.1592 11.3003C13.5654 10.6128 14.1123 10.0659 14.7998 9.65967C15.4873 9.25342 16.2373 9.05029 17.0498 9.05029C17.8623 9.05029 18.6123 9.25342 19.2998 9.65967C19.9873 10.0659 20.5342 10.6128 20.9404 11.3003C21.3467 11.9878 21.5498 12.7378 21.5498 13.5503H23.0498C23.0498 12.394 22.7412 11.3354 22.124 10.3745C21.5068 9.41357 20.6982 8.68311 19.6982 8.18311C20.2764 7.76123 20.7295 7.23389 21.0576 6.60107C21.3857 5.96826 21.5498 5.28467 21.5498 4.55029C21.5498 3.73779 21.3467 2.98779 20.9404 2.30029C20.5342 1.61279 19.9873 1.06592 19.2998 0.659668C18.6123 0.253418 17.8623 0.050293 17.0498 0.050293C16.2373 0.050293 15.4873 0.253418 14.7998 0.659668C14.1123 1.06592 13.5654 1.61279 13.1592 2.30029C12.7529 2.98779 12.5498 3.73779 12.5498 4.55029C12.5498 5.28467 12.7139 5.96826 13.042 6.60107C13.3701 7.23389 13.8232 7.76123 14.4014 8.18311C13.2607 8.74561 12.3936 9.56592 11.7998 10.644C11.2061 9.56592 10.3389 8.74561 9.19824 8.18311C9.77637 7.76123 10.2295 7.23389 10.5576 6.60107C10.8857 5.96826 11.0498 5.28467 11.0498 4.55029C11.0498 3.73779 10.8467 2.98779 10.4404 2.30029C10.0342 1.61279 9.4873 1.06592 8.7998 0.659668C8.1123 0.253418 7.3623 0.050293 6.5498 0.050293ZM6.5498 1.55029C7.09668 1.55029 7.60059 1.68311 8.06152 1.94873C8.52246 2.21436 8.88574 2.57764 9.15137 3.03857C9.41699 3.49951 9.5498 4.00342 9.5498 4.55029C9.5498 5.09717 9.41699 5.60107 9.15137 6.06201C8.88574 6.52295 8.52246 6.88623 8.06152 7.15186C7.60059 7.41748 7.09668 7.55029 6.5498 7.55029C6.00293 7.55029 5.49902 7.41748 5.03809 7.15186C4.57715 6.88623 4.21387 6.52295 3.94824 6.06201C3.68262 5.60107 3.5498 5.09717 3.5498 4.55029C3.5498 4.00342 3.68262 3.49951 3.94824 3.03857C4.21387 2.57764 4.57715 2.21436 5.03809 1.94873C5.49902 1.68311 6.00293 1.55029 6.5498 1.55029ZM17.0498 1.55029C17.5967 1.55029 18.1006 1.68311 18.5615 1.94873C19.0225 2.21436 19.3857 2.57764 19.6514 3.03857C19.917 3.49951 20.0498 4.00342 20.0498 4.55029C20.0498 5.09717 19.917 5.60107 19.6514 6.06201C19.3857 6.52295 19.0225 6.88623 18.5615 7.15186C18.1006 7.41748 17.5967 7.55029 17.0498 7.55029C16.5029 7.55029 15.999 7.41748 15.5381 7.15186C15.0771 6.88623 14.7139 6.52295 14.4482 6.06201C14.1826 5.60107 14.0498 5.09717 14.0498 4.55029C14.0498 4.00342 14.1826 3.49951 14.4482 3.03857C14.7139 2.57764 15.0771 2.21436 15.5381 1.94873C15.999 1.68311 16.5029 1.55029 17.0498 1.55029Z"
                fill="#374151"
              />
            </svg>

            <span className=" ">
              {selectedCar?.doors ? selectedCar?.doors : "N/A"}{" "}
              <span>doors</span>{" "}
              {selectedCar?.seats ? selectedCar.seats : "N/A"}{" "}
              <span>seats</span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <DetailPagetLayout>
        <CarDetailImageCollage />
        <div className="my-12 ">{renderSection1()}</div>
        <div className="my-12 ">{renderSection2()}</div>
        <div className="my-12 ">{renderSection3()}</div>
        <div className="my-12 ">{renderSection4()}</div>
        <div className="my-12 flex justify-end">
          {" "}
          <ButtonPrimary
            className="rounded-xl"
            onClick={() => {
              navigate("/");
            }}
          >
            Book Now
          </ButtonPrimary>
        </div>
      </DetailPagetLayout>
    </div>
  );
};

export default CarDetail;
